const FakeOrders = [

    {
        _id: '651a52ec46a92da798190301',
        name: 'John Doe',
        email: 'john.doe@example.com',
        phone: '01008754291',
        orders: [
            { _id: '651a535346a92da7981o1', book: 'The Great Gatsby' },
            { _id: '651a535346a92da7981o2', book: '1984' }
        ]
    },

    {
        _id: '651a52ec46a92da798190302',
        name: 'Jane Smith',
        email: 'jane.smith@example.com',
        phone: '01008754292',
        orders: [
            { _id: '651a535346a92da7981o3', book: 'Moby-Dick' },
            { _id: '651a535346a92da7981o4', book: 'Pride and Prejudice' },
            { _id: '651a535346a92da7981o5', book: 'War and Peace' }
        ]
    },

    {
        _id: '651a52ec46a92da798190303',
        name: 'Omar Khaled',
        email: 'omar.khaled@example.com',
        phone: '01008754293',
        orders: [
            { _id: '651a535346a92da7981o6', book: 'The Final Gambit' }
        ]
    },

    {
        _id: '651a52ec46a92da798190304',
        name: 'Ahmed Ali',
        email: 'ahmed.ali@example.com',
        phone: '01008754294',
        orders: [
            { _id: '651a535346a92da7981o7', book: 'Brave New World' },
            { _id: '651a535346a92da7981o8', book: 'To Kill a Mockingbird' },
            { _id: '651a535346a92da7981o9', book: 'Fahrenheit 451' }
        ]
    },

    {
        _id: '651a52ec46a92da798190305',
        name: 'Sara Mohamed',
        email: 'sara.mohamed@example.com',
        phone: '01008754295',
        orders: [
            { _id: '651a535346a92da7981o10', book: '1984' },
            { _id: '651a535346a92da7981o11', book: 'The Catcher in the Rye' }
        ]
    },

    {
        _id: '651a52ec46a92da798190306',
        name: 'Khaled Mansour',
        email: 'khaled.mansour@example.com',
        phone: '01008754296',
        orders: [
            { _id: '651a535346a92da7981o12', book: 'The Lord of the Rings' }
        ]
    },

    {
        _id: '651a52ec46a92da798190307',
        name: 'Aya Ibrahim',
        email: 'aya.ibrahim@example.com',
        phone: '01008754297',
        orders: [
            { _id: '651a535346a92da7981o13', book: 'Moby-Dick' },
            { _id: '651a535346a92da7981o14', book: 'Anna Karenina' }
        ]
    },

    {
        _id: '651a52ec46a92da798190308',
        name: 'Mohamed Tarek',
        email: 'mohamed.tarek@example.com',
        phone: '01008754298',
        orders: [
            { _id: '651a535346a92da7981o15', book: 'The Odyssey' },
            { _id: '651a535346a92da7981o16', book: 'The Great Gatsby' },
            { _id: '651a535346a92da7981o17', book: '1984' }
        ]
    },

    {
        _id: '651a52ec46a92da798190309',
        name: 'Nour Youssef',
        email: 'nour.youssef@example.com',
        phone: '01008754299',
        orders: [
            { _id: '651a535346a92da7981o18', book: 'Pride and Prejudice' }
        ]
    },

    {
        _id: '651a52ec46a92da798190310',
        name: 'Hassan Hamed',
        email: 'hassan.hamed@example.com',
        phone: '01008754300',
        orders: [
            { _id: '651a535346a92da7981o19', book: 'The Brothers Karamazov' },
            { _id: '651a535346a92da7981o20', book: 'War and Peace' }
        ]
    },

    {
        _id: '651a52ec46a92da798190311',
        name: 'Fatma Adel',
        email: 'fatma.adel@example.com',
        phone: '01008754301',
        orders: [
            { _id: '651a535346a92da7981o21', book: 'The Picture of Dorian Gray' }
        ]
    },

    {
        _id: '651a52ec46a92da798190312',
        name: 'Yara Sami',
        email: 'yara.sami@example.com',
        phone: '01008754302',
        orders: [
            { _id: '651a535346a92da7981o22', book: 'War and Peace' },
            { _id: '651a535346a92da7981o23', book: 'Moby-Dick' }
        ]
    },

    {
        _id: '651a52ec46a92da798190313',
        name: 'Mahmoud Fathy',
        email: 'mahmoud.fathy@example.com',
        phone: '01008754303',
        orders: [
            { _id: '651a535346a92da7981o24', book: 'Anna Karenina' }
        ]
    },

    {
        _id: '651a52ec46a92da798190314',
        name: 'Heba El-Sayed',
        email: 'heba.sayed@example.com',
        phone: '01008754304',
        orders: [
            { _id: '651a535346a92da7981o25', book: 'One Hundred Years of Solitude' },
            { _id: '651a535346a92da7981o26', book: 'The Catcher in the Rye' }
        ]
    },

    {
        _id: '651a52ec46a92da798190315',
        name: 'Rami Salah',
        email: 'rami.salah@example.com',
        phone: '01008754305',
        orders: [
            { _id: '651a535346a92da7981o27', book: 'Crime and Punishment' }
        ]
    },

    {
        _id: '651a52ec46a92da798190316',
        name: 'Salma Nabil',
        email: 'salma.nabil@example.com',
        phone: '01008754306',
        orders: [
            { _id: '651a535346a92da7981o28', book: 'The Lord of the Rings' },
            { _id: '651a535346a92da7981o29', book: 'Brave New World' }
        ]
    },

    {
        _id: '651a52ec46a92da798190317',
        name: 'Ali Zaki',
        email: 'ali.zaki@example.com',
        phone: '01008754307',
        orders: [
            { _id: '651a535346a92da7981o30', book: 'Fahrenheit 451' }
        ]
    },

    {
        _id: '651a52ec46a92da798190318',
        name: 'Marwa Saad',
        email: 'marwa.saad@example.com',
        phone: '01008754308',
        orders: [
            { _id: '651a535346a92da7981o31', book: 'Don Quixote' },
            { _id: '651a535346a92da7981o32', book: 'The Odyssey' }
        ]
    },

    {
        _id: '651a52ec46a92da798190319',
        name: 'Tamer Shawky',
        email: 'tamer.shawky@example.com',
        phone: '01008754309',
        orders: [
            { _id: '651a535346a92da7981o33', book: 'The Odyssey' }
        ]
    },

];

export default FakeOrders;